import styles from './Separator.module.scss';

export interface SeparatorProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

export const Separator = (props: SeparatorProps) => {
  return (
    <div
      {...props}
      className={styles.separator}
      data-test-id="separator-container"
    />
  );
};
